import { SwRegistrationOptions } from '@angular/service-worker';
import { environment } from 'src/environments/environment';

export const ServiceWorkerConfig: SwRegistrationOptions = {
  // Register the ServiceWorker as soon as the application is stable
  // or after 30 seconds (whichever comes first).
  registrationStrategy: 'registerWhenStable:30000',
  enabled: environment.env === 'dev',
};
